import { render, staticRenderFns } from "./record-material.vue?vue&type=template&id=5a4302dc&scoped=true"
import script from "./record-material.vue?vue&type=script&lang=js"
export * from "./record-material.vue?vue&type=script&lang=js"
import style0 from "./record-material.vue?vue&type=style&index=0&id=5a4302dc&prod&scoped=true&leng=scss&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4302dc",
  null
  
)

export default component.exports